import React from 'react'
import { MagnifyingGlass } from '@phosphor-icons/react'

export default function RbacAssignmentSearch({ value, onChange, onSearch, placeholder, disabled, error = false, describedBy }) {
  return (
    <div className={`rbac-assignment-search filter-ubiqua-mui-picker-search${error ? ' rbac-assignment-search--error' : ''}`}>
      <MagnifyingGlass size={17} aria-hidden="true" />
      <input
        type="search"
        aria-label={placeholder}
        aria-describedby={describedBy}
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault()
            onSearch?.()
          }
        }}
        disabled={disabled}
        autoComplete="off"
      />
    </div>
  )
}
